module.exports = __webpack_public_path__ + "static/media/apexpurplesmall.ffd32bfe.gif";